/* Decoraton — warstwa custom: drawer fix, fly-to-cart, przecena Strefy */
(function () {
  'use strict';

  /* --- 1. Koszyk: niezawodne otwieranie drawera (delegacja, capture — odporna na re-render ikony) --- */
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('#cart-icon-bubble') : null;
    if (!link) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    if ((location.pathname || '').indexOf('/cart') !== -1) return;
    e.preventDefault();
    drawer.open(link);
  }, true);

  /* --- 2. Fly-to-cart + puls ikony --- */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[name="add"], .quick-add__submit') : null;
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;
    var b = btn.getBoundingClientRect();
    var c = cartIcon.getBoundingClientRect();
    var dot = document.createElement('span');
    dot.className = 'deco-fly-dot';
    dot.style.left = (b.left + b.width / 2) + 'px';
    dot.style.top = (b.top + b.height / 2) + 'px';
    document.body.appendChild(dot);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        dot.style.transform = 'translate(' + (c.left + c.width / 2 - b.left - b.width / 2) + 'px,' + (c.top + c.height / 2 - b.top - b.height / 2) + 'px) scale(.3)';
        dot.style.opacity = '0.15';
      });
    });
    setTimeout(function () {
      dot.remove();
      var icon = document.getElementById('cart-icon-bubble');
      if (icon) {
        icon.classList.add('deco-pulse');
        setTimeout(function () { icon.classList.remove('deco-pulse'); }, 600);
      }
    }, 780);
  }, true);

  /* --- 3. Strefa: wizualna przecena na stronie produktu ---
     Plakietka liczy rabat od AKTUALNIE wyświetlanej ceny wariantu i odtwarza się
     po każdym re-renderze bloku ceny (zmiana wariantu w Dawn). */
  function strefaActive() {
    try {
      var exp = parseInt(localStorage.getItem('snc_deadline'), 10);
      return localStorage.getItem('snc_access') === '1' && !isNaN(exp) && exp > Date.now();
    } catch (err) { return false; }
  }
  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var withComma = amount.replace('.', ',');
    var f = format || '{{amount_with_comma_separator}} zł';
    return f
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }
  function currentProductHandle() {
    var m = (location.pathname || '').match(/\/products\/([a-z0-9\-]+)/);
    return m ? m[1] : null;
  }
  function displayedPriceCents() {
    var box = document.querySelector('.product__info-container .price, product-info .price');
    if (!box) return null;
    var el = box.querySelector('.price__sale .price-item--sale') ||
             box.querySelector('.price__regular .price-item--regular') ||
             box.querySelector('.price-item');
    if (!el) return null;
    var t = (el.textContent || '').replace(/\s/g, '').replace(/[^\d,\.]/g, '');
    if (t.indexOf(',') > -1 && t.indexOf('.') > -1) {
      t = t.replace(/\./g, '').replace(',', '.');
    } else {
      t = t.replace(',', '.');
    }
    var v = parseFloat(t);
    return isNaN(v) ? null : Math.round(v * 100);
  }
  function renderNote(priceCents, moneyFormat) {
    var priceBox = document.querySelector('.product__info-container .price, product-info .price');
    if (!priceBox || !priceCents) return;
    var existing = document.querySelector('.deco-strefa-note');
    if (existing && parseInt(existing.getAttribute('data-cents'), 10) === priceCents) return;
    if (existing) existing.remove();
    var now = Math.round(priceCents * 0.8);
    var isEn = (document.documentElement.lang || 'pl').indexOf('en') === 0;
    var note = document.createElement('div');
    note.className = 'deco-strefa-note';
    note.setAttribute('data-cents', priceCents);
    note.innerHTML = '<span class="deco-strefa-tag">' + (isEn ? 'Zone −20%' : 'Strefa −20%') + '</span>' +
      '<s>' + formatMoney(priceCents, moneyFormat) + '</s>' +
      '<strong>' + formatMoney(now, moneyFormat) + '</strong>' +
      '<span>' + (isEn ? 'code applied in cart' : 'kod naliczony w koszyku') + '</span>';
    priceBox.parentNode.insertBefore(note, priceBox.nextSibling);
  }
  var strefaEligible = false;
  function refreshStrefaNote() {
    if (!strefaEligible) return;
    var cents = displayedPriceCents();
    var fmt = null;
    if (window.decoStrefaProduct) {
      if (cents == null) cents = window.decoStrefaProduct.price;
      fmt = window.decoStrefaProduct.moneyFormat;
    }
    if (cents != null) renderNote(cents, fmt);
  }
  function initStrefaProduct() {
    if (!strefaActive()) return;
    var handle = currentProductHandle();
    if (!handle) return;
    if (window.decoStrefaProduct) {
      strefaEligible = true;
    } else {
      var list = '';
      try { list = localStorage.getItem('snc_products') || ''; } catch (err) {}
      if ((',' + list + ',').indexOf(',' + handle + ',') === -1) return;
      strefaEligible = true;
    }
    refreshStrefaNote();
    /* Dawn przy zmianie wariantu podmienia blok ceny — odtwarzamy plakietkę */
    var info = document.querySelector('product-info') || document.querySelector('.product__info-container');
    if (info && 'MutationObserver' in window) {
      var t = null;
      var mo = new MutationObserver(function (muts) {
        var relevant = false;
        for (var i = 0; i < muts.length; i++) {
          var n = muts[i].target;
          if (n && n.nodeType === 1 && n.closest && n.closest('.deco-strefa-note')) continue;
          relevant = true;
          break;
        }
        if (!relevant) return;
        clearTimeout(t);
        t = setTimeout(refreshStrefaNote, 150);
      });
      mo.observe(info, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStrefaProduct);
  } else {
    initStrefaProduct();
  }

  /* --- 4. WhatsApp — pływający przycisk click-to-chat ---
     Otwiera czat z numerem Decoraton (wa.me). Numer i tekst konfigurowane niżej.
     Zbudowany w JS, więc nie rusza theme.liquid. Nie dubluje się (guard po id). */
  var WA_NUMBER = '48605642777';           // numer w formacie międzynarodowym bez '+', spacji i znaków
  function waInject() {
    if (document.getElementById('deco-wa-fab')) return;
    if (!document.body) return;

    var isEn = (document.documentElement.lang || 'pl').indexOf('en') === 0;
    var label = isEn ? 'Message us on WhatsApp' : 'Napisz na WhatsApp';
    var prefill = isEn
      ? 'Hello! I have a question about Decoraton Colour products.'
      : 'Dzień dobry! Mam pytanie o produkty Decoraton Colour.';

    var css = ''
      + '.deco-wa-fab{position:fixed;left:22px;bottom:24px;z-index:9998;display:flex;align-items:center;'
      + 'width:56px;height:56px;border-radius:28px;background:#25D366;box-shadow:0 6px 20px rgba(0,0,0,.25);'
      + 'text-decoration:none;overflow:hidden;transition:width .35s cubic-bezier(.16,1,.3,1),box-shadow .3s,opacity .3s ease,transform .3s cubic-bezier(.16,1,.3,1);}'
      + '.deco-wa-fab svg{flex:0 0 56px;width:56px;height:56px;padding:14px;box-sizing:border-box;display:block;}'
      + '.deco-wa-fab .deco-wa-txt{white-space:nowrap;color:#fff;font-family:\'Inter\',system-ui,sans-serif;'
      + 'font-size:13px;letter-spacing:.02em;opacity:0;transition:opacity .25s;padding-right:22px;}'
      + '.deco-wa-fab.deco-wa-hidden{opacity:0;transform:translateY(24px) scale(.8);pointer-events:none;}'
      + '.deco-wa-fab::after{content:\'\';position:absolute;left:0;top:0;width:56px;height:56px;border-radius:50%;'
      + 'box-shadow:0 0 0 0 rgba(37,211,102,.5);animation:decoWaPulse 2.6s infinite;pointer-events:none;}'
      + '@keyframes decoWaPulse{0%{box-shadow:0 0 0 0 rgba(37,211,102,.45);}70%{box-shadow:0 0 0 14px rgba(37,211,102,0);}100%{box-shadow:0 0 0 0 rgba(37,211,102,0);}}'
      + '.deco-wa-fab:active{transform:scale(.94);}'
      + '@media(min-width:750px){.deco-wa-fab:hover{width:auto;box-shadow:0 8px 26px rgba(0,0,0,.3);}'
      + '.deco-wa-fab:hover .deco-wa-txt{opacity:1;}.deco-wa-fab:hover::after{animation:none;box-shadow:none;}}'
      + '@media(max-width:749px){body.template-product .deco-wa-fab{bottom:88px;}}'
      + '@media(prefers-reduced-motion:reduce){.deco-wa-fab::after{animation:none;}}';

    var style = document.createElement('style');
    style.id = 'deco-wa-style';
    style.textContent = css;
    document.head.appendChild(style);

    var a = document.createElement('a');
    a.id = 'deco-wa-fab';
    a.className = 'deco-wa-fab';
    a.href = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(prefill);
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.setAttribute('aria-label', label);
    a.innerHTML = '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">'
      + '<path fill="#fff" d="M16.04 4C9.9 4 4.9 9 4.9 15.14c0 2.16.62 4.18 1.7 5.9L4.5 28l7.16-2.02a11.1 11.1 0 0 0 4.38.9h.01c6.14 0 11.14-5 11.14-11.14C27.19 9 22.18 4 16.04 4zm0 20.4h-.01a9.24 9.24 0 0 1-4.71-1.29l-.34-.2-4.25 1.2 1.13-4.14-.22-.35a9.2 9.2 0 0 1-1.42-4.92c0-5.1 4.15-9.24 9.26-9.24 2.47 0 4.79.96 6.54 2.71a9.18 9.18 0 0 1 2.71 6.54c0 5.1-4.15 9.28-9.25 9.28zm5.08-6.92c-.28-.14-1.65-.81-1.9-.9-.26-.1-.44-.14-.63.14-.19.28-.72.9-.88 1.09-.16.19-.32.21-.6.07-.28-.14-1.18-.43-2.24-1.38-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.49.14-.16.19-.28.28-.47.09-.19.05-.35-.02-.49-.07-.14-.63-1.51-.86-2.07-.23-.55-.46-.47-.63-.48l-.54-.01c-.19 0-.49.07-.75.35-.26.28-.98.96-.98 2.33 0 1.38 1 2.71 1.14 2.9.14.19 1.97 3.01 4.77 4.22.67.29 1.19.46 1.6.59.67.21 1.28.18 1.76.11.54-.08 1.65-.67 1.88-1.32.23-.65.23-1.2.16-1.32-.07-.12-.26-.19-.54-.33z"/>'
      + '</svg><span class="deco-wa-txt">' + label + '</span>';
    document.body.appendChild(a);

    /* Chowanie przy scrollu (glownie telefon): znika w trakcie scrollowania, wraca po ~0.65s bezruchu */
    var waHideTimer;
    window.addEventListener('scroll', function () {
      if (window.innerWidth > 749) return;
      a.classList.add('deco-wa-hidden');
      clearTimeout(waHideTimer);
      waHideTimer = setTimeout(function () { a.classList.remove('deco-wa-hidden'); }, 650);
    }, { passive: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waInject);
  } else {
    waInject();
  }
})();

/* Wysokość stałego nagłówka -> zmienna CSS --dec-header-h (używana przez deco-custom.css do odsunięcia treści).
   Mierzymy tylko w stanie „niescrollowanym” (nagłówek pełnej wysokości). */
(function () {
  var root = document.documentElement;
  var last = 0;
  function measure() {
    if (document.body && document.body.classList.contains('scrolled')) return;
    var hw = document.querySelector('.header-wrapper');
    if (!hw) return;
    var h = Math.round(hw.getBoundingClientRect().height);
    if (h > 40 && h !== last) { last = h; root.style.setProperty('--dec-header-h', h + 'px'); }
  }
  function init() {
    measure();
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('load', measure);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(measure); }
    var hw = document.querySelector('.header-wrapper');
    if (hw && window.ResizeObserver) { new ResizeObserver(measure).observe(hw); }
    setTimeout(measure, 800);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
